import { FC } from 'react';
import { ChipTypeMap } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Chip } from '../../../atomic';
import { TooltipComponent } from '../../../atomic/feedback';
import { CardApprovalRequest, CardRequestStatus } from '../../../../../queries/pxtraCard';
import { failureText } from '../utils';

// The list only ever holds a request that can still be decided.
const statusColors: Partial<Record<CardRequestStatus, ChipTypeMap['props']['color']>> = {
  open: 'info',
  failed: 'error'
};

export const StatusChip: FC<{ request: CardApprovalRequest }> = ({ request }) => {
  const { t } = useTranslation();
  // Open and already at Swan is not the same thing as open: the cards exist
  // over there and only the signature is missing, so deciding again reopens
  // that signature rather than doing anything new.
  const awaiting = request.status === 'open' && request.awaiting_signature;
  const chip = (
    <Chip
      label={t(
        awaiting ? 'pxtraCard:status_awaitingSignature' : `pxtraCard:status_${request.status}`
      )}
      color={awaiting ? 'warning' : (statusColors[request.status] ?? 'neutral')}
      // The shared chip shouts by default; a status reads better as a word.
      sx={{ textTransform: 'none' }}
    />
  );

  if (awaiting) {
    return (
      <TooltipComponent title={t('pxtraCard:awaitingSignatureText')} placement="top" arrow>
        <span>{chip}</span>
      </TooltipComponent>
    );
  }

  const failure = failureText(request, t);

  if (request.status !== 'failed' || !failure) return chip;

  return (
    <TooltipComponent title={failure} placement="top" arrow>
      <span>{chip}</span>
    </TooltipComponent>
  );
};
